import React from "react";
import BaseDetails from "./baseDetails";

export default function noDetails({ row }) {
    return <BaseDetails row={row}>{null}</BaseDetails>;
}
